"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackLinkContextProvider = exports.useBackLink = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _router = _interopRequireDefault(require("next/router"));
var _LanguageProvider = require("./LanguageProvider");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var BackLinkContext = /*#__PURE__*/_react["default"].createContext();
var BackLinkContextProvider = function BackLinkContextProvider(props) {
  var _global$__appConfig__;
  var urlsToSkip = ["/checkout", "/checkout/payment", "/checkout/success"];
  var isUrlToSkip = function isUrlToSkip(url) {
    return urlsToSkip.some(function (page) {
      return url.includes(page);
    });
  };
  var url = props.router.asPath;
  var _useState = (0, _react.useState)([url]),
    urlHistory = _useState[0],
    setUrlHistory = _useState[1];
  var _useState2 = (0, _react.useState)("/"),
    backLink = _useState2[0],
    setBackLink = _useState2[1];
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var domains = (_global$__appConfig__ = global.__appConfig__.domainLanguages) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : [];
  var baseUrl = "https://".concat(Object.keys(domains).find(function (domain) {
    return domains[domain] === language.language;
  }));
  (0, _react.useEffect)(function () {
    var handler = function handler(url) {
      setUrlHistory(function (prevUrlHistory) {
        var lastUrl = prevUrlHistory[prevUrlHistory.length - 1];
        setBackLink(isUrlToSkip(lastUrl) ? "/" : lastUrl);
        return [].concat((0, _toConsumableArray2["default"])(prevUrlHistory), [url]).slice(-2);
      });
    };
    _router["default"].events.on("routeChangeComplete", handler);
    return function () {
      _router["default"].events.off("routeChangeComplete", handler);
    };
  }, []);
  return __jsx(BackLinkContext.Provider, {
    value: {
      backLink: backLink
    }
  }, props.children);
};
exports.BackLinkContextProvider = BackLinkContextProvider;
var useBackLink = function useBackLink() {
  var _useContext = (0, _react.useContext)(BackLinkContext),
    backLink = _useContext.backLink;
  return backLink;
};
exports.useBackLink = useBackLink;